import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { PopoverComponent, PopoverPlacement } from '@ui';
import { HelpTemplateComponent } from './help-center-template.component';
import { ButtonComponent } from '../../../../ui/components/atoms/button/button.component';
import { IconComponent } from '../../../../ui/components/atoms/icon/icon.component';
import { MENU_HELP_CENTER_ITEMS } from '../../config/menu.config';
import { HelpTemplateItem } from './help-center.models';
import * as packageJson from '../../../../../package.json';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PopoverComponent, HelpTemplateComponent, ButtonComponent, IconComponent],
  selector: 'app-help-center',
  template: `
    <ui-popover
      [placement]="placement()"
      [visible]="visible()"
      (popoverVisibleChange)="setVisiblePopover($event)"
    >
      <!-- Popover trigger -->
      <ui-button buttonType="text" classes="px-2 rounded-full">
        <ui-icon icon="question-circle" [class]="'text-[16px]'" />
      </ui-button>

      <!-- The content of the popover is provided as a template -->
      <div popover-content class="flex flex-col gap-y-3 max-w-72">
        <app-help-template
          [items]="menu"
          (sendClose)="setVisiblePopover(false)"
        />
        <span class="text-xs self-end mr-2.5 text-gray-400">Volta Analytics v{{appVersion}}</span>
      </div>
    </ui-popover>
  `,
})
export class HelpCenterComponent {
  protected readonly appVersion = packageJson.version

  placement = input<PopoverPlacement>('bottomRight');
  visible = signal<boolean>(false);
  menu: HelpTemplateItem[] = MENU_HELP_CENTER_ITEMS;

  setVisiblePopover(visible: boolean) {
    this.visible.set(visible);
  }
}
